import React, { FC } from 'react';
import { IconButton, SvgIcon, Theme, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useIntl } from 'react-intl';
import { ReactComponent as DeleteIcon } from 'img/icons/x-bold_deprecated.svg';
import unMessages from 'common/messages/userNotifications';

const useStyles = makeStyles((theme: Theme) => ({
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '16px',
  },
  btnClose: {
    color: theme.palette.darkBackground?.light,
    marginRight: '-4px',
  },
}));

interface IUserNotificationsHeader {
  onClose: () => void;
}

const UserNotificationsHeader: FC<IUserNotificationsHeader> = ({ onClose }) => {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <div className={classes.header}>
      <Typography variant="h3">
        {intl.formatMessage(unMessages.userNotificationsPopoverTitle)}
      </Typography>

      <IconButton className={classes.btnClose} size="small" onClick={onClose}>
        <SvgIcon component={DeleteIcon} />
      </IconButton>
    </div>
  );
};

export default UserNotificationsHeader;
